// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1wacr","info":"Note_info__3glBC","note":"Note_note__1Mk_7","actions":"Note_actions__1x2Cs"};